import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../../context/tenant-context';
import { v2Component } from '../../../../index';
import { ToastContainer } from 'react-toastify';
import { AliasesField } from './aliases-field';
import { AliasType } from '../../../../clients/quipli-service/alias/alias';

export function initCategoryAliasesField(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('category-aliases-field');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, name, initialAliases, inputId, ...props } = Object.assign(
          {},
          element.dataset,
        ) as any;

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <AliasesField
                name={name}
                initialAliases={initialAliases}
                inputId={inputId}
                aliasType={AliasType.Category}
                {...props}
              />
            </TenantContext.Provider>,
          ),
        );
        const event = new CustomEvent('change');
        element.dispatchEvent(event);
      };

      bootstrap();
    }
  });
}

export function initProductAliasesField(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('product-aliases-field');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, name, initialAliases, inputId, ...props } = Object.assign(
          {},
          element.dataset,
        ) as any;

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <AliasesField
                name={name}
                initialAliases={initialAliases}
                inputId={inputId}
                aliasType={AliasType.Product}
                {...props}
              />
            </TenantContext.Provider>,
          ),
        );
        const event = new CustomEvent('change');
        element.dispatchEvent(event);
      };

      bootstrap();
    }
  });
}
